<template>
  <div>
      <v-card class="pa-4">
          <v-data-table
              :headers="headers"
              :items="items"
              item-key="farmNumber"
              :items-per-page="10"
              :loading="loading"
              loading-text="Loading... Please wait"
              :options.sync="tableOptions"
              :server-items-length="totalRecords"
              :footer-props="{'items-per-page-options': itemsPerPageOptions, showFirstLastPage: true,'items-per-page-text': $t('geneticsAndBreeding.rowsPerPage') }"
              @pagination="paginationChanged"
              :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal'
              }"
          >
          <template v-slot:top>
            <div class="d-flex mt-5">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                outlined
                :placeholder="$t('geneticsAndBreeding.searchByAnimalIdName')"
                dense
                style="max-width:25%"
                v-model="search"
                @input="searchEPD"
              ></v-text-field>
              <!-- <v-btn
                :disabled="search.length < 1"
                color="primary"
                height="40"
                width="40"
                max-width="40"
                outlined
                class="ml-8"
                @click="searchEPD"
              >
                <v-icon>mdi-filter-outline</v-icon>
              </v-btn> -->
              <v-spacer></v-spacer>
              <div class="pt-2 pr-2 black--text">
                {{ $t('geneticsAndBreeding.rowsPerPage') }}
              </div>
              <v-select style="max-width:63px;" v-model="tableOptions.itemsPerPage"  dense :items="itemsPerPageOptions" class="mr-5"></v-select>
              <div class="py-1 title">
                {{ from }} - {{ to }} of {{ totalRecords }}
              </div>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page <= 1"
                @click="pageChange(false)"
              >
                <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                :disabled="tableOptions.page >= totalPages"
                @click="pageChange(true)"
              >
                <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
                @click="$router.push({name: 'GeneticsGrid'})"
              >
                <v-icon dark> mdi-view-grid-outline </v-icon>
              </v-btn>
              <!-- <v-btn
                class="mx-2"
                fab
                small
                outlined
                color="primary"
              >
                <v-icon dark> mdi-format-list-bulleted </v-icon>
              </v-btn> -->
            </div>
          </template>
          <template v-slot:progress>
              <v-progress-linear
                  color="primary"
                  :height="8"
                  indeterminate
              ></v-progress-linear>
          </template>
          <template v-slot:item.animalNumber="{item}">
              <span><a @click.prevent="$router.push({name: 'SingleAnimalEpd', params: {geneticid: item.animalNumber}})">{{ item.animalNumber }}</a></span>
          </template>
          <template v-slot:header.birthWeight="{}">
              <span class="">{{ $t('animal.birthWeight') }}({{ weightUnit }})</span>
          </template>
          <template v-slot:item.birthWeight="{item}">
            <span class="text-capitalize">{{(!item.birthWeight || Number.isInteger(item.birthWeight)) ? item.birthWeight : (item.birthWeight).toFixed(2) }}</span>
          </template>
          <template v-slot:header.weaningWeight="{}">
            <span class="">{{ $t('geneticsAndBreeding.weaningWeight') }}({{ weightUnit }})</span>
          </template>
          <template v-slot:item.weaningWeight="{item}">
            <span class="text-capitalize">{{ (!item.weaningWeight || Number.isInteger(item.weaningWeight)) ? item.weaningWeight : (item.weaningWeight).toFixed(2) }}</span>
          </template>
          <template v-slot:header.yearlingWeight="{}">
            <span class="">{{ $t('geneticsAndBreeding.yearlingWeight') }}({{ weightUnit }})</span>
          </template>
          <template v-slot:item.yearlingWeight="{item}">
            <span class="text-capitalize">{{ ( !item.yearlingWeight || Number.isInteger(item.yearlingWeight))? item.yearlingWeight : (item.yearlingWeight).toFixed(2) }}</span>
          </template>
          <template v-slot:item.birthDate="{item}">
            <span class="text-no-wrap">{{ item.birthDate }}</span>
          </template>
          <template v-slot:item.actions="{item}">
              <v-btn icon @click="$router.push({name: 'EditGenetics', params: {geneticid: item.animalNumber  }})"><v-icon>mdi-pencil</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-card>
  </div>
</template>
<script>
import EPDService from "@/_services/EPDService";

export default {
mounted() {
  // if(this.$route.query.page){
  //   this.tableOptions.page = Number(this.$route.query.page)
  // }else{
  //   this.$router.replace(
  //     {query: { page: this.tableOptions.page}}
  //   )
  // }
},
  watch: {
      tableOptions: {
          handler() {
            this.getEPDData();
          },
          deep: true,
      },
      '$route.query': {
        handler(v) {
          if(v?.page){
            this.tableOptions.page = Number(v.page)
          }else{
            this.$router.replace(
              {query: { page: this.tableOptions.page}}
            )
          }
        },
        deep: true,
        immediate: true
      }
  },
  computed: {
    weightUnit() {
      return (this.weightUnitt || 'lbs').toLowerCase()
    }
  },
  data() {
      return {
        itemsPerPageOptions: [10, 25, 50, 100,500],
          weightUnitt: 'lbs',
          loading: false,
          search: "",
          selected: [],
          totalRecords: 1,
          totalPages: 0,
          to: 0,
          from: 0,
          tableOptions: {},
          items: [],
          headers: [
              {
                  text: this.$t('geneticsAndBreeding.animalID'),
                  value: "animalNumber",
                  class: "text-no-wrap black--text",
                  align: 'start',
              },
              {
                  text: this.$t('geneticsAndBreeding.animalName'),
                  value: "name",
                  class: "text-no-wrap black--text px-0",
                  align: 'start',
              },
              {
                  text: this.$t('geneticsAndBreeding.tag'),
                  value: "tagNumber",
                  class: "text-no-wrap black--text",
                  align: 'start',
              },
              {
                  text: this.$t('geneticsAndBreeding.gender'),
                  value: "gender",
                  class: "text-no-wrap black--text",
                  align: 'start',
              },
              { text: this.$t('geneticsAndBreeding.birthDate'), value: "birthDate", class: "text-no-wrap black--text", align: 'start', },
              {
                  text: this.$t('geneticsAndBreeding.birthWeightLb'),
                  value: "birthWeight",
                  class: "black--text text-no-wrap px-0",
                  align: 'start',
              },
              { text: this.$t('geneticsAndBreeding.weaningWeightLb'), value: "weaningWeight",align: 'start', class: "black--text text-no-wrap px-0" },
              {
                  text: this.$t('geneticsAndBreeding.yearlingWeightLb'),
                  value: "yearlingWeight",
                  class: "black--text text-no-wrap px-0",
                  align: 'start',
              },
              {
                  text: this.$t(''),
                  value: "actions",
                  sortable: false,
                  align: 'start',
                  class: "black--text text-no-wrap ",
                  width: '10%'
              },
          ],

      }
  },
  methods: {
    getEPDData() {
      this.loading = true
      EPDService.getEPD(
        this.tableOptions,
        this.search
      )
      .then(res => {
        this.items = res.data.rows
        this.weightUnitt = res.data.weightUnit;
        this.totalRecords = res.data.count;
        this.totalPages = Math.ceil(
          this.totalRecords / this.tableOptions.itemsPerPage
        );
        this.from =
          (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
        this.to =
            this.tableOptions.page * this.tableOptions.itemsPerPage -
            (this.tableOptions.itemsPerPage - res.data.returnedRecords);
        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        console.log('err', err)
      })
    },
    searchEPD() {
      this.tableOptions.page = 1;
      this.items = [];
      this.getEPDData();
    },

    resetSearchOnEmpty() {
      if (this.search !== "") return;
      this.tableOptions.page = 1;
      this.getEPDData();
    },

    pageChange(t) {
          if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
          else this.tableOptions.page = Number(this.tableOptions.page) - 1;

          // this.$router.replace(
          //   {query: { page: this.tableOptions.page}}
          // )
          // this.getEPDData();
      },
      paginationChanged() {
        this.$router.replace(
            {query: { page: this.tableOptions.page}}
          )
      }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-data-table-header th {
white-space: nowrap;
}
::v-deep .v-data-table-header__icon {
display: inline-block;
opacity: 100 !important;
transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>